import { DeviceType } from "./device.model";

export namespace DeviceUtil {
	export function getDeviceSpecificCrsKey(crsKey: string, deviceType: DeviceType): string {
		const platformPostfix = deviceType === DeviceType.Desktop ? DeviceType.Desktop : DeviceType.Mobile;
		return `${crsKey}-${platformPostfix.toLocaleLowerCase()}`;
	}
}
